import { NgModule } from '@angular/core';

import { LazyLoadElementsDirective } from './lazy-load-elements.directive';
import { LazyLoadImageDirective } from './lazy-load-images.directive';
import { LazyLoadObserverService } from './lazy-load-observer.service';
import { LazyPosterDirective } from './lazy-load-poster.directive';
import { LazyLoadTemplateDirective } from './lazy-load-template.directive';
import { LazyLoadConfig } from './lazy-load.config';


@NgModule({
  imports: [],
  exports: [
    LazyLoadElementsDirective,
    LazyLoadImageDirective,
    LazyLoadTemplateDirective,
    LazyPosterDirective
  ],
  declarations: [
    LazyLoadElementsDirective,
    LazyLoadImageDirective,
    LazyLoadTemplateDirective,
    LazyPosterDirective
  ],
  providers: [
    LazyLoadObserverService,
    LazyLoadConfig
  ]
})
export class LazyLoadModule {}
